import React, { useEffect } from "react";

function ToastItem({ toast, onDismiss }) {
  useEffect(() => {
    const timer = setTimeout(() => onDismiss(toast.id), 4000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`myaccount-message ${toast.severity} text-white`}>
      {toast.message}
    </div>
  );
}

export default ToastItem;
